/** Shahar nomi ko'rinib turgan tilda: widgets:clock.cities.<zona>, bo'lmasa zona nomidan */
import type { TFunction } from "i18next";
import { zoneCity } from "./time";
import type { ClockZone } from "./config";

export function cityName(tz: string, t: TFunction): string {
  return t(`clock.cities.${tz}`, { ns: "widgets", defaultValue: zoneCity(tz) });
}

export function zoneName(zone: ClockZone, t: TFunction): string {
  return zone.label || cityName(zone.tz, t);
}
